import { router, usePage } from '@inertiajs/vue3'
import VueScrollTo from 'vue-scrollto'
import { nextTick } from 'vue'

export function scrollToTop(speed = 500, options = {}) {
	VueScrollTo.scrollTo('body', speed, {
		...options,
	})
}

export function scrollTo(element = 'body', speed = 500, options = {}) {
	VueScrollTo.scrollTo(element, speed, options)
}

export function goToAndScrollTo(url, elementId) {
	const page = usePage()
	if (page.url !== url) {
		router.visit(url, {
			preserveScroll: false,
			onSuccess: () => {
				nextTick(() => {
					scrollTo(elementId)
				})
			},
		})
	} else {
		scrollTo(elementId)
	}
}

export function formatDate(payload) {
	const date = new Date(payload)
	const formattedDate = date.toLocaleDateString('en-AU', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
	})
	return formattedDate
}

export function formatDateNumeric(payload) {
	const date = new Date(payload)
	const formattedDate = date.toLocaleDateString('en-AU', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	})
	return formattedDate
}

export function formatDateFromNumeric(payload) {
	const [day, month, year] = payload.split('/')
	const date = new Date(Number(year), Number(month) - 1, Number(day))
	return date.toISOString()
}

export function formatDay(payload) {
	const date = new Date(payload)
	const dayName = date.toLocaleDateString('en-AU', { weekday: 'short' })
	return dayName
}

export function formatDayDate(payload) {
	if (!(payload instanceof Date)) {
		return ''
	}

	const formatedDay = formatDay(payload)
	const formatedDate = formatDate(payload)
	return `${formatedDay}, ${formatedDate}`
}

export function formatCurrency(value, decimal = false, config = {}) {
	const fraction = decimal ? 2 : 0
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		// this needs to be USD as AUD will be displayed as A$
		currency: 'USD',
		minimumFractionDigits: fraction,
		maximumFractionDigits: fraction,
		...config,
	})
	return formatter.format(
		typeof value !== 'number' ? Number.parseFloat(value) : value
	)
}

export function stripHTML(html) {
	const doc = new DOMParser().parseFromString(html, 'text/html')
	return doc.body.textContent || ''
}
